import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { translate, fragmentsSort, titleConvert, classConvert, colorConvert, convertVideoResolution, videoPositionClass, getCurrentLanguage, informantNameDisplay, informantNameDisplayWidthBr, menuEntrys, formatDate, getPosterframe } from '../assets/js/functions';
import Layout from "../components/Layout";
import { domain, getApartat, getFragmentfromIndexLocator } from "../assets/js/api";
import Slider from "react-slick";
import ReactPlayer from 'react-player'
import ViewGallery from '../components/Partials/ViewGallery'
import ViewGalleryMobile from '../components/Partials/ViewGalleryMobile'
import ViewHeader from "../components/Partials/ViewHeader";
import ViewVideo from "../components/Partials/ViewVideo";

import IcoPlay from "../assets/img/ico-play.svg";
import IcoStop from "../assets/img/ico-stop.svg";
import IcoVolum from "../assets/img/ico-volum.svg";
import IcoMute from "../assets/img/ico-mute.svg";
import IcoAnterior from "../assets/img/ico-anterior.svg";
import IcoSeguent from "../assets/img/ico-seguent.svg";
import IcoDesplegar from "../assets/img/ico-desplegar-menu.svg";
import IcoPlegar from "../assets/img/ico-plegar-menu.svg";
import IcoSliderAnt from "../assets/img/ico-anterior.svg";
import IcoSliderNext from "../assets/img/ico-seguent.svg";

import "slick-carousel/slick/slick.css";
//import "slick-carousel/slick/slick-theme.css";



function SliderNextArrow(props) {
    const { className, onClick } = props;
    return (
    <button onClick={onClick} type="button" className={className+" button is-text p-0 is-flex-shrink-0"}>
        <img loading="lazy" src={IcoSliderNext} alt={translate("Següent")} width="59" height="42"/>
    </button>
    );
}

  function SliderPrevArrow(props) {
    const { className, onClick } = props;
    return (
    <button onClick={onClick} type="button" className={className+" button is-text p-0 is-flex-shrink-0"}>
        <img loading="lazy" src={IcoSliderAnt} alt={translate("Anterior")} width="59" height="42"/>
    </button>
    );
}


export default function View(props){

    const [declaracions, setDeclaracions] = useState(null);
    const [declaracionsIndex, setDeclaracionsIndex] = useState(0);
    const [interview, setInterview] = useState(null);
    const [informant, setInformant] = useState(null);
    const [gallery, setGallery] = useState(null);

    const [mobileDeclarationsIndex, setMobileDeclarationsIndex] = useState(0);
    const [mobileCurrentDeclaration, setMobileCurrentDeclaration] = useState(null);

    const [pause, setPause] = useState(true);
    const [mute, setMute] = useState(false);

    const [expand, setExpand] = useState(false);
    const [galleryOpen, setGalleryOpen] = useState(false);

    const sliderSettings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        nextArrow: <SliderNextArrow />,
        prevArrow: <SliderPrevArrow />
    };

    function pauseToggle() {
        setPause(!pause);
    }

    function muteToggle() {
        setMute(!mute);
    }

    useEffect(() => {
        setDeclaracions(null);
        setInterview(null);
        setInformant(null);
        setGallery(null);
        setDeclaracionsIndex(0);
        getApartat(props.match.params.group).then(res => {
            setGallery(res.other_images);

            const promise = res.indexations.map(
                i => {
                    return getFragmentfromIndexLocator(JSON.stringify(i)).then(
                        interview => {
                            return interview.data.result;
                        }
                    )
                }
            )
            Promise.all(promise).then(
                response => {
                    let fragments = []
                    response.map(value => {
                        if (value[0].result && value[1].result && value[1].result.length > 0) {
                            const elem = [value[0].result, value[1].result[0]];
                            fragments.push(elem);
                        }
                    });
                    fragments = fragmentsSort(fragments);

                    UpdateIndex(parseInt(props.match.params.id)?parseInt(props.match.params.id):0, fragments);
                    setDeclaracions(fragments.length > 0?fragments:[]);
                }
            )
        });
    }, [props.match.params.group])

    useEffect(() => {
        if (declaracions === null || typeof props.match.params.id === 'undefined') {
            return;
        }
        UpdateIndex(parseInt(props.match.params.id), declaracions);
    }, [props.match.params.id])

    useEffect(() => {
        setExpand((props.match.params.expand === 'declarations')?true:false);

        if (props.match.params.gallery === 'gallery') {
            setExpand(true);
            setGalleryOpen(true);
        } else {
            setGalleryOpen(false);
        }

    }, [props.match.params.expand, props.match.params.gallery])

    function UpdateIndex(index, declaracions) {
        setPause(true);
        if (index < 0) {
            index = declaracions.length;
        }
        if (index > declaracions.length) {
            index = 0;
        }
        setDeclaracionsIndex(index);
        setInterview(declaracions[index][1]);
        setInformant(declaracions[index][1].informant[0]);
        setMobileDeclarationsIndex(0);
        setMobileCurrentDeclaration(declaracions[0]);

    }

    function prevUrl() {
        let index = declaracionsIndex - 1;
        if (index < 0) {
            index = declaracions.length - 1;
        }
        return '/'+props.match.params.group+'/'+index;
    }

    function nextUrl() {
        let index = declaracionsIndex + 1;
        if (index >= declaracions.length) {
            index = 0;
        }
        return '/'+props.match.params.group+'/'+index;
    }

    function mobileDeclarationPrev() {
        let index = mobileDeclarationsIndex - 1;
        if (index < 0) {
            index = declaracions.length - 1;
        }
        setMobileDeclarationsIndex(index);
        setMobileCurrentDeclaration(declaracions[index]);
    }
    function mobileDeclarationNext() {
        let index = mobileDeclarationsIndex + 1;
        if (index >= declaracions.length) {
            index = 0;
        }
        setMobileDeclarationsIndex(index);
        setMobileCurrentDeclaration(declaracions[index]);
    }

    return (
        <Layout pageMeta={{
        }}>
        {declaracions?
        <div className={"page-container is-flex is-flex-direction-column "+ classConvert(props.match.params.group)}>
            <ViewHeader group={props.match.params.group} index={declaracionsIndex} expand={expand} gallery={galleryOpen} />

            {(galleryOpen)?
                <ViewGalleryMobile group={props.match.params.group} gallery={gallery} declaracionsIndex={declaracionsIndex} />
            :
            ''}
            {(expand && !galleryOpen)?
            <>
            <div className={"is-hidden-tablet px-7 is-flex-grow-1 "+ classConvert(props.match.params.group)}>
                <h2 className="has-text-centered is-size-7 my-7">{translate('Declaracions')}</h2>
                <div className="is-flex is-justify-content-space-between is-align-items-center mb-6">
                    <button type="button" onClick={event => {event.preventDefault();mobileDeclarationPrev()}} className="button is-text p-0 is-flex-shrink-0">
                        <img loading="lazy" src={IcoSliderAnt} alt={translate('Anterior')} width="59" height="42"/>
                    </button>
                    <span className="is-size-5 has-text-weight-bold">{mobileDeclarationsIndex+1} {translate('de')} {declaracions.length}</span>
                    <button type="button" onClick={event => {event.preventDefault();mobileDeclarationNext()}} className="button is-text p-0 is-flex-shrink-0">
                        <img loading="lazy" src={IcoSliderNext} alt={translate('Següent')} width="59" height="42"/>
                    </button>
                </div>
                <div className="slider">
                    <Link to={'/'+props.match.params.group+'/'+mobileDeclarationsIndex} className="is-block has-text-black link-dn">
                        <div className="is-relative is-flex-grow-1">
                            <img src={getPosterframe(domain+mobileCurrentDeclaration[0].posterframe_url)} width="380" height="212" alt="" className="is-block"/>
                            <svg width="39" height="29" xmlns="http://www.w3.org/2000/svg">
                                <g fill="none" fillRule="evenodd">
                                    <path stroke={colorConvert(props.match.params.group)} strokeWidth="3" d="M37.5 27h-36V2h36z" />
                                    <path fill={colorConvert(props.match.params.group)} d="m27.5 15-16 8V7z" />
                                </g>
                            </svg>
                        </div>
                        <h3 className="has-text-centered has-text-weight-bold is-size-3 is-family-secondary mt-6">{informantNameDisplay(mobileCurrentDeclaration[1].informant[0])}</h3>
                    </Link>
                </div>
                {gallery?
                <div className="has-text-centered">
                    <Link to={'/'+props.match.params.group+'/'+declaracionsIndex+'/declarations/gallery'} type="button" className="button button--icon button--galeria mx-auto mt-8">
                        <span>{translate('Veure galeria d\'imatges')}</span>
                    </Link>
                </div>
                :''}
            </div>
            </>
            :''}

            {declaracions.map((value, index) => {
                const fragment = value[0];
                return <ViewVideo key={index} fragment={fragment} pauseGlobal={pause} mute={mute} index={index} current={declaracionsIndex} mobileHidden={(expand || galleryOpen)}/>
            })};
            <div className={"info-box px-6 py-6 "+ videoPositionClass(interview) + " " + classConvert(props.match.params.group)+" "+((expand || galleryOpen)?'is-hidden-mobile':'')}>
                <div className="columns is-mobile">
                    <div className="column">
                        <h1>{informantNameDisplayWidthBr(informant)}</h1>
                        <p className="mt-3">
                        {informant.birthplace_municipality}, <time dateTime={informant.birthdate}>{formatDate(informant.birthdate)}</time>
                        </p>
                        {informant.education_level?
                        <p className="mt-3">{informant.education_level}</p>
                        :''}

                    </div>
                </div>
                <blockquote className="">
                    {interview.other_documentation?
                    <p className="has-text-weight-black is-size-9 has-text-centered">{interview.other_documentation}</p>
                    :''}
                </blockquote>
                <div className="video-controls is-flex is-justify-content-space-between is-align-items-center mt-5">
                    <Link to={prevUrl()} className="button is-text p-0">
                        <img loading="lazy" src={IcoAnterior} alt={translate('Anterior')} width="59" height="42"/>
                    </Link>
                    <div className="is-flex gap-2">
                        <button onClick={(event) => {event.preventDefault();pauseToggle()}} type="button" className="button is-text p-0">
                        {pause?
                            <img src={IcoPlay} alt={translate('Reprodueix')} width="44" height="44"/>
                            :
                            <img loading="lazy" src={IcoStop} alt={translate('Pausa')} width="44" height="44"/>
                        }
                        </button>
                        <button onClick={(event) => {event.preventDefault();muteToggle()}} type="button" className="button is-text p-0">
                        {mute?
                            <img src={IcoMute} alt={translate('Silencia')} width="44" height="44"/>
                            :
                            <img loading="lazy" src={IcoVolum} alt={translate('Activa el so')} width="44" height="44"/>
                        }
                        </button>
                    </div>
                    <Link to={nextUrl()} className="button is-text p-0">
                        <img loading="lazy" src={IcoSeguent} alt={translate('Següent')} width="59" height="42"/>
                    </Link>
                </div>
                <div className="has-text-centered is-hidden-tablet is-lowercase mt-5">
                    <Link to={'/'+props.match.params.group+'/'+declaracionsIndex+'/declarations'} className="link-dn">{translate('Veure totes les declaracions')}</Link>
                </div>
            </div>

            <div className="main-nav w-100 is-hidden-mobile">
                {expand?
                <Link to={'/'+props.match.params.group+'/'+declaracionsIndex} aria-expanded="true" aria-controls="content" className="has-text-centered is-block is-text mx-auto mb-4 p-0">
                    <img loading="lazy" src={IcoPlegar} alt="" width="44" height="44"/>
                    <span className="is-sr-only">{translate('Tancar més informació')}</span>
                </Link>
                :
                <div class="is-flex is-align-items-center">
                <Link to={'/'+props.match.params.group+'/'+declaracionsIndex+'/declarations'} aria-expanded="false" aria-controls="content" className="is-flex is-align-items-center mx-auto mb-4 p-0 is-lowercase has-text-black has-text-weight-black link-dn is-size-11">
                    <img loading="lazy" src={IcoDesplegar} alt="" width="44" height="44" class="is-flex-shrink-0"/>
                    <span class="pl-2">{translate('Menú')}</span>
                </Link>
                </div>
                }
                <div className="main-nav__container has-background-white p-6" id="content" aria-hidden={!expand}>
                    <nav>
                        <ul className="is-flex is-flex-wrap-wrap gap-4 is-justify-content-center is-align-items-center is-lowercase has-text-centered">
                            {menuEntrys().map(value =>
                            <li key={value}>
                                <Link to={'/'+value} className={"has-text-black is-block is-family-secondary radius-large is-size-5 px-4 py-2 mb-2 "+classConvert(value)} aria-current={(props.match.params.group === value)?'page':''}>{titleConvert(value)}</Link>
                                <Link to={'/'+value+'/declarations'} className="has-text-black is-block is-lowercase link-dn">{translate('Veure declaracions')}<span className="is-sr-only"> "{titleConvert(value)}"</span></Link>
                            </li>
                        )}
                        </ul>
                    </nav>
                    <div className="pt-6 pb-8">
                        <div className="wrapper flow flow--large">
                            <h1 className="has-text-centered is-lowercase is-family-secondary is-size-1">{translate('Cuidar')} {titleConvert(props.match.params.group)}</h1>
                            <h2>{translate('Declaracions')}</h2>

                            <Slider {...sliderSettings}>
                                {declaracions.map((value, index) => {
                                const fragment = value[0];
                                const informant = value[1].informant[0];
                                return <Link key={index} to={'/'+props.match.params.group+'/'+index} className="is-flex is-flex-direction-column has-text-black link-dn h-100">
                                        <div className="is-relative is-flex-grow-1">
                                            <img src={getPosterframe(domain+fragment.posterframe_url)} width="380" height="212" alt="" className="is-block"/>
                                            <svg width="39" height="29">
                                                <g fill="none" fillRule="evenodd">
                                                    <path stroke={colorConvert(props.match.params.group)} strokeWidth="3" d="M37.5 27h-36V2h36z" />
                                                    <path fill={colorConvert(props.match.params.group)} d="m27.5 15-16 8V7z" />
                                                </g>
                                            </svg>
                                        </div>
                                        <h3 className={"has-text-centered has-text-weight-bold p-4 mt-auto is-size-9 is-flex is-flex-direction-column is-justify-content-center "+classConvert(props.match.params.group)}>
                                            {informantNameDisplay(informant)}
                                        </h3>
                                    </Link>
                                })}
                            </Slider>

                            <ViewGallery group={props.match.params.group} gallery={gallery} declaracionsIndex={declaracionsIndex} />

                        </div>
                    </div>
                </div>
            </div>
        </div>
        :
        <div className="loading-container">
                <div className="loading"></div>
            </div>
        }
        </Layout>
    )
}
